define('companiesMain',[
  'module',
  'logger',
  'companiesMainRouter'
], function (
  module,
  Logger
) {
  'use strict';

  var Companies = {
    start: function () {
      Logger.log(module, 'starting CompaniesModule');
    },

    stop: function () {
      Logger.log(module, 'stopping CompaniesModule');
    }
  };

  module.exports = Companies;
});

